(function(){
  'use strict';
  const ONE=67836454338659,TWO=67836454371427,PROTECTION=44552817901667;
  const tr=(key,fallback)=>window.kidneyI18n?.t(key,fallback)||fallback;
  const localizedRoute=route=>window.kidneyI18n?.route(route)||route;
  const drawer=document.querySelector('[data-cart-drawer]');
  const template=drawer?.querySelector('[data-cart-item]')?.cloneNode(true);
  let cart=null,busy=false,readVersion=0,returnFocus=null,navigating=false;
  const money=n=>{const amount=Number(n||0)/100,currency=cart?.currency||'USD';return currency==='USD'?'$'+amount.toFixed(2):new Intl.NumberFormat('en',{style:'currency',currency}).format(amount);};
  const text=(root,selector,value)=>root.querySelectorAll(selector).forEach(n=>n.textContent=value);
  const offer=()=>document.querySelector('[data-bundle-card].selected')||document.querySelector('[data-bundle="bogo"]');
  const variant=()=>offer()?.dataset.bundle==='single'?ONE:TWO;
  const merchandise=value=>(value?.items||[]).filter(item=>Number(item.variant_id)!==PROTECTION);
  async function request(route,body){
    const response=await fetch(localizedRoute(route),{method:body?'POST':'GET',credentials:'same-origin',cache:'no-store',
      headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});
    const raw=await response.text();let result;
    try{result=JSON.parse(raw);}catch{}
    if(!response.ok||!result){const error=new Error(result?.description||result?.message||tr('cartError','The cart could not be updated. Please try again.'));error.status=response.status;throw error;}
    return result;
  }
  function open(){
    if(!drawer)return;
    if(!drawer.classList.contains('is-open')){returnFocus=document.activeElement;drawer.querySelector('.cart-panel-body').scrollTop=0;}
    drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('cart-drawer-open');
    drawer.querySelector('.cart-panel-header [data-cart-close]')?.focus({preventScroll:true});
  }
  function close(){
    if(!drawer)return;
    drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('cart-drawer-open');
    if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});
  }
  function errorMessage(message=''){
    if(!drawer)return;
    let node=drawer.querySelector('[data-live-cart-error]');
    if(!node){node=document.createElement('p');node.className='live-cart-error';node.dataset.liveCartError='';node.setAttribute('role','alert');drawer.querySelector('.cart-panel-body').prepend(node);}
    node.hidden=!message;node.textContent=message;
    if(message){const link=document.createElement('a');link.href=localizedRoute('/cart');link.textContent=tr('viewCart','View cart');node.append(document.createTextNode(' '),link);}
  }
  function setBusy(value){
    busy=value;
    document.querySelectorAll('[data-live-add]').forEach(n=>{n.disabled=value;n.toggleAttribute('aria-busy',value);});
    if(!drawer)return;
    drawer.querySelectorAll('[data-cart-increase],[data-cart-decrease],[data-cart-remove]').forEach(n=>n.disabled=value);
    const hasItems=merchandise(cart).length>0;
    const toggle=drawer.querySelector('[data-shipping-protection-toggle]');if(toggle)toggle.disabled=value||!hasItems;
    drawer.querySelector('[data-cart-checkout]')?.setAttribute('aria-disabled',String(value||!hasItems));
  }
  function render(value){
    cart=value;text(document,'[data-cart-count],.cart-count',value.item_count);
    if(!drawer||!template)return;
    drawer.querySelectorAll('[data-cart-item]').forEach(n=>n.remove());
    const empty=drawer.querySelector('[data-cart-empty]'),items=merchandise(value);
    let bundleSavings=0;
    for(const item of items){
      const id=Number(item.variant_id),bogo=id===TWO;
      const node=template.cloneNode(true);node.hidden=false;node.dataset.liveLine=item.key;node.dataset.liveQuantity=item.quantity;
      const card=[ONE,TWO].includes(id)?document.querySelector('[data-bundle="'+(id===ONE?'single':'bogo')+'"]'):null;
      const image=node.querySelector('img');if(image){image.src=card?.dataset.cartImage||item.image||image.src;image.alt=item.product_title;}
      text(node,'h3',item.product_title);text(node,'[data-cart-bundle-name]',id===TWO?tr('bogoTitle',item.variant_title):id===ONE?tr('singleTitle',item.variant_title):item.variant_title==='Default Title'?'':item.variant_title);
      text(node,'[data-cart-quantity]',item.quantity);text(node,'[data-cart-item-price]',money(item.final_line_price));
      node.querySelector('[data-cart-remove]')?.setAttribute('aria-label',tr('remove','Remove')+' '+item.product_title);
      const comparePrice=(bogo?2:1)*Number(item.original_line_price||item.final_line_price);
      const savings=Math.max(0,comparePrice-item.final_line_price);
      const compare=node.querySelector('[data-cart-compare-price]');if(compare){compare.textContent=money(comparePrice);compare.hidden=!savings;}
      text(node,'[data-cart-savings]',savings?tr('save','Save')+' '+money(savings):'');
      const savingText=node.querySelector('[data-cart-savings]');if(savingText?.parentElement)savingText.parentElement.hidden=!savings;
      const badge=node.querySelector('[data-cart-discount-badge]');if(badge)badge.hidden=!bogo;
      bundleSavings+=Math.max(0,comparePrice-Number(item.original_line_price||item.final_line_price));
      empty?.before(node);
    }
    if(empty)empty.hidden=items.length>0;
    const bogo=value.items.some(i=>Number(i.variant_id)===TWO);
    const savings=bundleSavings+Number(value.total_discount||0);
    const discounts=drawer.querySelector('[data-cart-discount-line]');
    if(discounts){
      discounts.hidden=!items.length||savings<=0;
      discounts.querySelectorAll('[data-cart-welcome-code],[data-cart-mystery-code],[data-cart-bogo-code]').forEach(n=>n.hidden=true);
      const code=discounts.querySelector('[data-cart-bogo-code]');if(code&&bogo){code.hidden=false;text(code,'span',tr('bogoLabel','BUY 1 GET 1 FREE'));}
      text(discounts,'[data-cart-discount-amount]','- '+money(savings));
    }
    let notice=drawer.querySelector('[data-live-cart-offer]');
    if(!notice){notice=document.createElement('div');notice.className='cart-offer-notice';notice.dataset.liveCartOffer='';drawer.querySelector('.cart-panel-footer').before(notice);}
    notice.hidden=!bogo;notice.textContent='◉ '+tr('bogoNotice','Buy 1 Get 1 FREE applied — complete checkout to enjoy it');
    const checkout=drawer.querySelector('[data-cart-checkout]');if(checkout){checkout.href=localizedRoute('/checkout');checkout.textContent=tr('checkout','Checkout')+' · '+money(value.total_price);}
    const toggle=drawer.querySelector('[data-shipping-protection-toggle]');
    if(toggle){const active=value.items.some(i=>Number(i.variant_id)===PROTECTION);toggle.setAttribute('aria-checked',String(active));toggle.setAttribute('aria-label',active?tr('shippingEnabled','Shipping protection enabled'):tr('shippingDisabled','Shipping protection disabled'));}
    setBusy(busy);
  }
  async function refresh(){const version=++readVersion;const value=await request('/cart.js');if(version===readVersion)render(value);return value;}
  function select(card){
    document.querySelectorAll('[data-bundle-card]').forEach(n=>{n.classList.toggle('selected',n===card);n.setAttribute('aria-pressed',String(n===card));});
    document.querySelectorAll('.price-line').forEach(n=>{const s=n.querySelector('s');if(s)s.textContent=card.dataset.cartCompare||'$59.00';const badge=n.querySelector('span');if(badge)badge.hidden=card.dataset.bundle==='single';});
    const input=document.querySelector('form[data-live-product-form] input[name="id"]');if(input)input.value=String(card.dataset.bundle==='single'?ONE:TWO);
  }
  function nativeAdd(id){
    let form=document.querySelector('form[data-live-product-form]');
    if(!form){form=document.createElement('form');form.method='post';form.action='/cart/add';form.dataset.liveProductForm='';for(const name of ['id','quantity','return_to']){const input=document.createElement('input');input.type='hidden';input.name=name;form.appendChild(input);}document.body.appendChild(form);}
    const destination=new URL(location.href);destination.searchParams.set('cart_open','1');destination.hash='';
    form.action=localizedRoute('/cart/add');
    form.elements.namedItem('id').value=String(id);form.elements.namedItem('quantity').value='1';
    form.elements.namedItem('return_to').value=destination.pathname+destination.search;
    navigating=true;HTMLFormElement.prototype.submit.call(form);
  }
  const quantity=(value,id)=>(value.items||[]).reduce((total,item)=>total+(Number(item.variant_id)===id?item.quantity:0),0);
  async function add(){
    if(busy)return;
    const id=variant();if(!id)return;setBusy(true);++readVersion;errorMessage();
    open();
    try{
      try{
        await request('/cart/add.js',{items:[{id,quantity:1}]});
        await refresh();
      }catch(error){
        if([400,404,422].includes(error.status)){
          await refresh().catch(()=>{});
          errorMessage(error.message);return;
        }
        nativeAdd(id);
      }
    }finally{if(!navigating)setBusy(false);}
  }
  async function mutate(action){
    if(busy)return;setBusy(true);++readVersion;errorMessage();
    try{
      await action();let value=await refresh();
      if(!merchandise(value).length){
        const protection=value.items.find(i=>Number(i.variant_id)===PROTECTION);
        if(protection){await request('/cart/change.js',{id:protection.key,quantity:0});await refresh();}
      }
    }catch(error){await refresh().catch(()=>{});errorMessage(error.message);open();}
    finally{setBusy(false);}
  }
  document.addEventListener('click',async function(event){
    const card=event.target.closest('[data-bundle-card]');if(card){event.preventDefault();event.stopImmediatePropagation();select(card);return;}
    if(event.target.closest('[data-live-add],[data-product-deep-add]')){event.preventDefault();event.stopImmediatePropagation();await add();return;}
    if(event.target.closest('[data-cart-close]')){event.preventDefault();event.stopImmediatePropagation();close();return;}
    if(event.target.closest('.cart-button,[data-live-cart-open]')){
      if(!drawer)return;event.preventDefault();event.stopImmediatePropagation();if(busy)return;
      errorMessage();try{await refresh();}catch(error){errorMessage(error.message);}open();return;
    }
    const change=event.target.closest('[data-cart-decrease],[data-cart-increase],[data-cart-remove]');
    if(change){
      event.preventDefault();event.stopImmediatePropagation();const line=change.closest('[data-live-line]');if(!line)return;
      const amount=change.hasAttribute('data-cart-remove')?0:Number(line.dataset.liveQuantity)+(change.hasAttribute('data-cart-increase')?1:-1);
      await mutate(()=>request('/cart/change.js',{id:line.dataset.liveLine,quantity:Math.max(0,amount)}));return;
    }
    if(event.target.closest('[data-shipping-protection-toggle]')){
      event.preventDefault();event.stopImmediatePropagation();
      await mutate(async()=>{if(!cart)await refresh();if(!merchandise(cart).length)return;
        const protection=cart.items.find(i=>Number(i.variant_id)===PROTECTION);
        if(protection)await request('/cart/change.js',{id:protection.key,quantity:0});
        else await request('/cart/add.js',{items:[{id:PROTECTION,quantity:1}]});});return;
    }
    if(event.target.closest('[data-cart-checkout]')&&(busy||!merchandise(cart).length)){event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('submit',event=>{if(event.target.matches('form[data-live-product-form]')){event.preventDefault();event.stopImmediatePropagation();void add();}},true);
  document.addEventListener('keydown',event=>{
    if(!drawer?.classList.contains('is-open'))return;
    if(event.key==='Escape'){event.preventDefault();close();}
    if(event.key==='Tab'){
      const nodes=[...drawer.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')].filter(n=>n.getClientRects().length);
      const first=nodes[0],last=nodes.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
    }
  });
  function resumeDrawer(){
    const url=new URL(location.href);
    if(url.searchParams.get('cart_open')==='1'){
      url.searchParams.delete('cart_open');history.replaceState(history.state,'',url.pathname+url.search+url.hash);
      refresh().then(open).catch(error=>{errorMessage(error.message);open();});
    }
  }
  window.addEventListener('pageshow',event=>{if(event.persisted||navigating){navigating=false;setBusy(false);}resumeDrawer();});
  if(drawer){drawer.querySelector('.cart-panel')?.setAttribute('role','dialog');drawer.querySelector('.cart-panel')?.setAttribute('aria-modal','true');render({items:[],item_count:0,total_price:0,total_discount:0});refresh().catch(()=>{});}
  if(offer())select(offer());
  resumeDrawer();
})();
